import s from "./ReportPageTitle.module.scss";

interface IProps {
  value: string;
  setValue: (v: string) => void;
  portfolioName: string;
}

export const ReportPageTitle = ({ value, setValue, portfolioName }: IProps) => {
  const setValueAugmented = (v: string) => {
    const augmentedValue = v.replace(portfolioName, "$portfolioName");
    setValue(augmentedValue);
  };
  return (
    <input
      className={s.input}
      value={value}
      onChange={(v) => setValueAugmented(v.target.value)}
    />
  );
};
